<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    app
    clipped
    width="230"
    dark
    color="#112A46"
    class="qp-nav-drawer"
  >
    <template v-slot:prepend>
      <SvgIcon
        class="p-x-5 p-t-5 p-b-8"
        img-styles="width:100%;height:auto;max-width:112px"
        :icon="Logo"
      />
    </template>
    <v-list-item-group
      v-model="item"
      class="navigation_krews"
      color="primary"
      mandatory
    >
      <v-list-item
        v-for="link in links"
        :key="link.value"
        :value="link.value"
        link
        active-class="navbar-active"
        class="navbar-item"
        @click="menuNavigation(link.action)"
      >
        <SvgIcon class="gap-x-4" :text="link.label">
          <template #icon>
            <component component="svg" :is="link.icon" class="icon" />
          </template>
        </SvgIcon>
      </v-list-item>
    </v-list-item-group>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from "@/main";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import Logo from "@/assets/images/logo-white.png";
import DashboardIcon from "@/assets/images/navigation/dashboard.svg";
import UserIcon from "@/assets/images/navigation/user.svg";
import TransactionsIcon from "@/assets/images/navigation/transactions.svg";
import LoginsIcon from "@/assets/images/navigation/logins.svg";
import VenuesIcon from "@/assets/images/navigation/venues.svg";
import MonitorIcon from "@/assets/images/navigation/monitor.svg"
import SupportIcon from "@/assets/images/navigation/support.svg";
import PartnersIcon from "@/assets/images/navigation/partners.svg";
import ClubsIcon from "@/assets/images/navigation/clubs.svg";
import SalesIcon from "@/assets/images/navigation/sales.svg";
import ReportsIcon from "@/assets/images/navigation/reports.svg";
import FeedIcon from "@/assets/images/navigation/feed-post.svg";
import InviteIcon from "@/assets/images/navigation/invite.svg";
import ModulesIcon from "@/assets/images/navigation/modules.svg";
import TournamentsIcon from "@/assets/images/navigation/tournaments.svg";
import PromotionsIcon from "@/assets/images/navigation/promotions.svg";
import EmployeesIcon from "@/assets/images/navigation/employees.svg";
import SponsoredIcon from "@/assets/images/navigation/sponsored.svg";
import GlobalConfigurations from "@/assets/images/navigation/config.svg";

export default {
  components: {
    SvgIcon,
    DashboardIcon,
    UserIcon,
    TransactionsIcon,
    LoginsIcon,
    MonitorIcon,
    VenuesIcon,
    SupportIcon,
    PartnersIcon,
    ClubsIcon,
    SalesIcon,
    ReportsIcon,
    FeedIcon,
    InviteIcon,
    ModulesIcon,
    TournamentsIcon,
    PromotionsIcon,
    EmployeesIcon,
    SponsoredIcon,
    GlobalConfigurations,
  },
  data: () => ({
    drawer: true,
    item: 0,
    mini: false,
    Logo,
  }),
  created() {
    EventBus.$on("changeIt", (data) => {
      this.drawer = data;
    });
    this.item = this.$route.meta.item;
  },
  watch: {
    $route() {
      this.item = this.$route.meta.item;
    },
  },
  methods: {
    menuNavigation(route) {
      if (this.$router.currentRoute.name != route) {
        this.$router.push({ name: route });
      }
    },
  },
  computed: {
    links() {
      return [
        {
          value: "dashboard",
          label: "Dashboard",
          icon: DashboardIcon,
          action: "Dashboard",
        },
        {
          value: "settings/users",
          label: "Users",
          icon: UserIcon,
          action: "UserSettings",
        },
        {
          value: "transactions",
          label: "Transactions",
          icon: TransactionsIcon,
          action: "Transactions",
        },
        {
          "value": "Monitoring",
          "label": "Monitoring",
          "icon": MonitorIcon,
          "action": 'Monitoring'
        },
        {
          value: "logins",
          label: "Logins",
          icon: LoginsIcon,
          action: "Logins",
        },
        {
          value: "venues",
          label: "Venues",
          icon: VenuesIcon,
          action: "Venues",
        },
        {
          value: "support",
          label: "Support Team",
          icon: SupportIcon,
          action: "SupportTeam",
        },
        {
          value: "partners",
          label: "Partners",
          icon: PartnersIcon,
          action: "Partners",
        },
        {
          value: "clubs",
          label: "Clubs",
          icon: ClubsIcon,
          action: "Club",
        },
        {
          value: "sales-team",
          label: "Sales Team",
          icon: SalesIcon,
          action: "SalesTeam",
        },
        {
          value: "reports",
          label: "Reports",
          icon: ReportsIcon,
          action: "Reports",
        },
        {
          value: "feedpost",
          label: "Feed Post",
          icon: FeedIcon,
          action: "FeedPost",
        },
        {
          value: "invite",
          label: "Invite",
          icon: InviteIcon,
          action: "Invite",
        },
        {
          value: "modules",
          label: "Modules",
          icon: ModulesIcon,
          action: "Modules",
        },
        {
          value: "tournaments",
          label: "Tournaments",
          icon: TournamentsIcon,
          action: "Tournaments",
        },
        {
          value: "promotions",
          label: "Promotions",
          icon: PromotionsIcon,
          action: "Promotions",
        },
        {
          value: "employees",
          label: "Employees",
          icon: EmployeesIcon,
          action: "Employees",
        },
        {
          value: "sponsoredposts",
          label: "Sponsored Posts",
          icon: SponsoredIcon,
          action: "SponsoredPosts",
        },
        {
          value: "global-configurations",
          label: "Configurations",
          icon: GlobalConfigurations,
          action: "GlobalConfigurations",
        },
      ];
    },
  },
};
</script>
<style scoped>
.navigation_krews {
  font-weight: 500;
}
.v-navigation-drawer {
  top: 0 !important;
  max-height: 100% !important;
}

.navbar-item {
  border-left: 6px solid transparent;
  border-bottom: none;
  font-size: 1rem;
  font-weight: 400;
  opacity: 0.6;
}

.navbar-active {
  background-color: #112a461a !important;
  border-left-color: #4faeaf;
  color: #ffffff !important;
  opacity: 1;
  font-weight: 500;
}

.navbar-active svg {
  stroke: #ffffff;
  stroke-width: 0.1;
  opacity: 1 !important;
}
</style>
